var _path, _g, _rect, _rect2, _rect3, _path2, _g2, _rect4, _rect5, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSectionIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 71,
    viewBox: "0 0 64 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 30C21 26.134 24.134 23 28 23H47.4217L52.8333 28.4117L59.2 34.7783V63.75C59.2 67.616 56.066 70.75 52.2 70.75H28C24.134 70.75 21 67.616 21 63.75V30Z",
    fill: "url(#paint0_linear_840_8319)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_840_8319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2418 29.8282L47.4215 23L59.1998 34.7783L52.3716 34.958C49.5078 35.0334 47.1664 32.692 47.2418 29.8282Z",
    fill: "url(#paint1_linear_840_8319)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.0931,
    y: 54.8333,
    width: 15.9167,
    height: 1.91,
    rx: 0.955,
    fill: "#B08032"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0931,
    y: 59.2898,
    width: 28.0133,
    height: 1.91,
    rx: 0.955,
    fill: "#B08032"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0931,
    y: 63.7466,
    width: 28.0133,
    height: 1.91,
    rx: 0.955,
    fill: "#B08032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0H26.0067L31.3333 5.32667L37.6 11.5933V40C37.6 43.866 34.466 47 30.6 47H7C3.13401 47 0 43.866 0 40V7Z",
    fill: "url(#paint2_linear_840_8319)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_840_8319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8316 6.63822L26.0063 0L37.5997 11.5933L30.9614 11.768C28.0977 11.8434 25.7563 9.50197 25.8316 6.63822Z",
    fill: "url(#paint3_linear_840_8319)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.01343,
    y: 31.3333,
    width: 15.6667,
    height: 1.88,
    rx: 0.94,
    fill: "#92E2A8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.01343,
    y: 35.72,
    width: 27.5733,
    height: 1.88,
    rx: 0.94,
    fill: "#92E2A8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.01343,
    y: 40.1067,
    width: 27.5733,
    height: 1.88,
    rx: 0.94,
    fill: "#92E2A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_840_8319",
    x: 43.24,
    y: 23,
    width: 19.9598,
    height: 19.9597,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_840_8319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_840_8319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_840_8319",
    x: 21.8298,
    y: 0,
    width: 19.7698,
    height: 19.7698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_840_8319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_840_8319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_8319",
    x1: 21,
    y1: 49.74,
    x2: 59.2,
    y2: 49.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECBC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00151691,
    stopColor: "#ECBC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00699072,
    stopColor: "#F8F0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0399991,
    stopColor: "#ECBC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_840_8319",
    x1: 48.084,
    y1: 34.7697,
    x2: 55.0615,
    y2: 28.4117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.668556,
    stopColor: "#F8F0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_840_8319",
    x1: 0,
    y1: 26.32,
    x2: 37.6,
    y2: 26.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C9C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00151691,
    stopColor: "#4C9C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00699072,
    stopColor: "#A2F4B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0399991,
    stopColor: "#4C9C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9C62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_840_8319",
    x1: 26.6584,
    y1: 11.5849,
    x2: 33.5263,
    y2: 5.32667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.668556,
    stopColor: "#E8FFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9C62"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionIcon1);
export default __webpack_public_path__ + "static/media/section-icon-1.d0ffd03f96b4d936217d795ed6549453.svg";
export { ForwardRef as ReactComponent };